import axios from "axios";
import jwt_decode from "jwt-decode";

const api_url = process.env.VUE_APP_APIURL;
const now = Date.now() / 1000;

const state = () => ({
  status: "",
  token: localStorage.getItem("token") || "",
  tokenTime: localStorage.getItem("tokenTime") || "",
  refreshToken: localStorage.getItem("refreshToken") || "",
  refreshTime: localStorage.getItem("refreshTime") || "",
  user: localStorage.getItem("user") || "",
  url: api_url,
});

const getters = {
  tokenExpires: (state) => {
    var expires = new Date(0);
    expires.setUTCSeconds(state.tokenTime);
    return expires;
  },

  refreshExpires: (state) => {
    var expires = new Date(state.refreshTime * 1000);
    return expires;
  },

  isLoggedIn: (state) => {
    if (state.token && state.tokenTime > now) {
      return true;
    } else {
      return false;
    }
  },
  hasRefreshToken: (state) => {
    if (state.refreshToken && state.refreshTime > now) {
      return true;
    } else {
      return false;
    }
  },
  authStatus: (state) => state.status,
};

const mutations = {
  auth_request(state) {
    state.status = "loading";
  },
  auth_success(state, payload) {
    state.token = payload.token;
    state.tokenTime = payload.tokenTime;
    state.refreshToken = payload.refreshToken;
    state.refreshTime = payload.refreshTime;
    state.user = payload.user;
    state.status = "success";

    localStorage.setItem("token", payload.token);
    localStorage.setItem("tokenTime", payload.tokenTime);
    localStorage.setItem("refreshToken", payload.efreshToken);
    localStorage.setItem("refreshTime", payload.refreshTime);
    localStorage.setItem("user", payload.user);

    axios.defaults.headers.common["Authorization"] = payload.token;
  },
  auth_refresh(state, token) {
    state.status = "success";
    state.token = token;
  },
  auth_error(state) {
    state.status = "error";
  },
  logout_clear(state) {
    state.status = "";
    state.token = "";
    state.tokenTime = "";
    state.refreshToken = "";
    state.refreshTime = "";
    state.user = "";

    localStorage.removeItem("token");
    localStorage.removeItem("tokenTime");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("refreshTime");

    delete axios.defaults.headers.common["Authorization"];
  },
};

const actions = {
  login({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit("auth_request");
      axios({
        url: "/.netlify/functions/auth_login",
        data: user,
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
      })
        .then((resp) => {
          console.log(resp.data);
          let decoded = jwt_decode(resp.data.token);
          let decodedRefresh = jwt_decode(resp.data.refreshToken);

          const token = resp.data.token;
          const tokenTime = decoded.exp;
          const refreshToken = resp.data.refreshToken;
          const refreshTime = decodedRefresh.exp;
          const user = resp.data.user;

          commit("auth_success", {
            token: token,
            tokenTime: tokenTime,
            refreshToken: refreshToken,
            refreshTime: refreshTime,
            user: user,
          });

          resolve(resp);
        })
        .catch((err) => {
          commit("auth_error");
          commit("logout_clear");
          reject(err);
        });
    });
  },
  tokenRefresh({ commit, rootState }) {
    console.log("Did i come here?");
    return new Promise((resolve, reject) => {
      commit("auth_refresh");
      axios({
        url: api_url + "/api/dashboard/auth/refresh",
        headers: {
          Authorization: `Bearer ${rootState.login.refreshToken}`,
          "Content-Type": "application/json",
        },
        method: "POST",
      })
        .then((resp) => {
          var decoded = jwt_decode(resp.data.token);
          var decodedRefresh = jwt_decode(resp.data.refreshToken);

          const token = resp.data.token;
          const tokenTime = decoded.exp;
          const refreshToken = resp.data.refreshToken;
          const refreshTime = decodedRefresh.exp;
          const user = resp.data.user;

          commit("auth_success", {
            token: token,
            tokenTime: tokenTime,
            refreshToken: refreshToken,
            refreshTime: refreshTime,
            user: user,
          });
        })
        .catch((err) => {
          commit("auth_error");
          commit("logout_clear");
          reject(err);
        });
    });
  },
  logout({ commit }) {
    return new Promise((resolve /*reject*/) => {
      commit("logout_clear");
      resolve();
    });
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
